import { List, ListSubheader, Typography } from '@mui/material'
import { deleteDoc, doc, Timestamp, updateDoc } from 'firebase/firestore'
import { firestore } from '../core'
import { Participant, Workout } from '../providers/workouts'
import ParticipantsListItem from './participants-list-item'
import { useUserHasWorkoutEditPermission } from '../hooks/permissions'
import { useAuth } from '../core/providers/auth'

type Props = {
  workout: Workout
}

const ParticipantsList = ({ workout }: Props) => {
  const editPermission = useUserHasWorkoutEditPermission(workout)
  const { user } = useAuth()
  const { participantsList, numberOfPlaces, id } = workout
  const handleRemoveParticipant = async (participantId: string) => {
    const docRef = doc(
      firestore,
      `/workouts/${id}/participants/${participantId}`
    )
    return deleteDoc(docRef)
  }
  const handleToggleCheckIn = async (participant: Participant) => {
    const participantRef = doc(
      firestore,
      'workouts',
      id,
      'participants',
      participant.uid
    )
    const checkedIn = !participant.checkedIn

    return updateDoc(participantRef, {
      checkedIn,
      checkedInAt: checkedIn ? Timestamp.now() : null,
      checkedInBy: checkedIn ? user?.uid ?? '' : null,
      checkedInByName: checkedIn ? user?.displayName ?? '' : null,
    })
  }

  return (
    <List
      subheader={
        <ListSubheader
          disableSticky
          sx={{ padding: 0, backgroundColor: 'transparent' }}>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
            {`Deltagare (${participantsList.length}/${numberOfPlaces})`}{' '}
          </Typography>
        </ListSubheader>
      }>
      {participantsList.map((participant) => {
        return (
          <ParticipantsListItem
            key={participant.uid}
            participant={participant}
            editPermission={editPermission}
            onRemoveParticipant={handleRemoveParticipant}
            onToggleCheckIn={handleToggleCheckIn}
          />
        )
      })}
    </List>
  )
}

export default ParticipantsList
